function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  d: "M40.4 13.2v16.793l2.124.007v-7.996h5.121v-2.115h-5.121v-4.575h6.668V13.2H40.4zm12.615 3.41c.764 0 1.385-.631 1.385-1.41 0-.777-.62-1.409-1.385-1.409s-1.385.632-1.385 1.41c0 .778.62 1.409 1.385 1.409zm-1.08 2.113v11.274h2.123V18.723h-2.123z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono",
  fill: "#000",
  d: "M62.368 18.4c-2.808 0-4.768 2.438-4.768 5.333s1.96 5.333 4.768 5.333c1.286 0 2.346-.511 3.117-1.343v1.508c0 1.877-1.436 3.446-3.31 3.446-.674 0-1.343-.268-1.876-.645l-1.06 1.883c.846.56 1.854.885 2.935.885 2.997 0 5.426-2.493 5.426-5.569V18.73h-2.115v1.012c-.771-.831-1.83-1.342-3.117-1.342zm-2.653 5.333c0-1.797 1.34-3.21 2.883-3.21 1.544 0 2.884 1.413 2.884 3.21s-1.34 3.21-2.884 3.21c-1.544 0-2.883-1.413-2.883-3.21z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  d: "M75.35 20.513c-1.3 0-2.353 1.083-2.353 2.36V30H70.8V18.728h2.197v1.033c.644-.818 1.592-1.361 2.83-1.361 1.54 0 2.72.752 3.404 1.902.762-1.11 2.003-1.902 3.497-1.902 2.5 0 4.057 1.984 4.072 4.438v7.161h-2.198v-7.126c0-1.278-1.052-2.36-2.352-2.36-1.299 0-2.352 1.082-2.352 2.36v7.126h-2.196v-7.126c0-1.278-1.054-2.36-2.353-2.36z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono",
  fill: "#000",
  d: "M98.213 20.017a5.301 5.301 0 0 0-3.85-1.617c-3.255 0-5.563 2.738-5.563 6s2.309 6 5.562 6a5.301 5.301 0 0 0 3.851-1.617v1.286h2.187V18.73h-2.187v1.286zM90.987 24.4c0-2.164 1.667-3.874 3.613-3.874s3.613 1.709 3.613 3.874c0 2.164-1.667 3.874-3.613 3.874s-3.613-1.709-3.613-3.874z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1ABCFE",
  fillRule: "nonzero",
  d: "M16.213 23.791c0-4.38 3.63-7.93 8.107-7.93 4.477 0 8.107 3.55 8.107 7.93s-3.63 7.93-8.107 7.93c-4.477 0-8.107-3.55-8.107-7.93z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0ACF83",
  fillRule: "nonzero",
  d: "M0 39.652c0-4.38 3.63-7.93 8.107-7.93h8.106v7.93c0 4.38-3.63 7.93-8.106 7.93-4.478 0-8.107-3.55-8.107-7.93z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7262",
  fillRule: "nonzero",
  d: "M16.213 0v15.86h8.107c4.477 0 8.107-3.55 8.107-7.93S28.797 0 24.32 0h-8.107z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F24E1E",
  fillRule: "nonzero",
  d: "M0 7.93c0 4.38 3.63 7.93 8.107 7.93h8.106V0H8.107C3.629 0 0 3.55 0 7.93z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A259FF",
  fillRule: "nonzero",
  d: "M0 23.791c0 4.38 3.63 7.93 8.107 7.93h8.106v-15.86H8.107C3.629 15.86 0 19.41 0 23.79z"
}));

var SvgFigma = function SvgFigma(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 48,
    viewBox: "0 0 100 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFigma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/figma.b9ec1d2d.svg";
export { ForwardRef as ReactComponent };